import zod from "zod";
import { fileSchema } from "./fileSchemas";

export const documentSchema = fileSchema.extend({
  file_type: zod.string(),
});

export const documentsSchema = zod.array(documentSchema);
export type Document = zod.infer<typeof documentSchema>;

export const requiredDocumentSchema = zod.object({
  id: zod.number(),
  name: zod.string(),
  description: zod.string().nullable().optional(),
  file_type: zod.string(),
  weight: zod.number().nullable(),
  required_count: zod.number(),
  uploaded_count: zod.number(),
});

export const requiredDocumentsSchema = zod.array(requiredDocumentSchema);
export type RequiredDocument = zod.infer<typeof requiredDocumentSchema>;

export const offerDocumentSchema = zod.object({
  id: zod.number(),
  files: documentsSchema,
  is_complete: zod.boolean(),
  name: zod.string(),
  description: zod.string().nullable().optional(),
  offer_stip_id: zod.number().nullable().optional(),
  application_stip_id: zod.number().nullable().optional(),
});
export type OfferDocument = zod.infer<typeof offerDocumentSchema>;

export const addDocumentSchema = zod.object({
  file: zod.instanceof(File),
  file_type: zod.string().nullable().optional(),
  offer_stip_id: zod.number().nullable().optional(),
  application_stip_id: zod.number().nullable().optional(),
  owner_id: zod.number().nullable().optional(),
  product_id: zod.number().nullable().optional(),
});
export type AddDocumentPayload = zod.infer<typeof addDocumentSchema>[];

export const updateDocumentSchema = zod.object({
  name: zod.string().optional(),
  type: zod.string().optional(),
  owner_id: zod.number().optional(),
});
export type UpdateDocumentPayload = zod.infer<typeof updateDocumentSchema>;

export const deleteDocumentSchema = zod.object({
  offer_stip_id: zod.number().optional(),
  application_stip_id: zod.number().optional(),
});
export type DeleteDocumentPayload = zod.infer<typeof deleteDocumentSchema>;
